var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-field',_vm._g(_vm._b({},'van-field',_vm.customizedAttrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }